import Form from "./form_controller"
import {removeErrorsOnFields} from "../utils/fields";

export default class extends Form {

    static targets = [
        "priceOutput"
    ]

    initialize() {
        super.initialize()
    }

    onSuccess(response) {
        removeErrorsOnFields(this.$inputs)
        let price = parseFloat(response.data.price)
        if ( window.Intl ) {
            price = new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR' }).format(price)
        }
        this.priceOutputTarget.innerHTML = price
    }

}